/*
{
  numRooms: {
    lt: 3,
    gt: 1
  },
  cat: {
    eq: 'category',
  }
}
*/

export const filtersSelected = (state = {}, action = {}) => {
  switch (action.type) {
    case 'SELECT_FILTER': {
      const { key, value, operator = 'eq' } = action.payload.filter;

      if (value === 'EMPTY') {
        const newState = { ...state };
        delete newState[key];
        return newState;
      }
      const prev = { ...state[key] } || {};

      return {
        ...state,
        [key]: {
          ...prev,
          [operator]: value,
        },
      };
    }
    case 'CLEAR_FILTERS':
      return {};
    default:
      return state;
  }
};
